<template>
  <div class="spreader_home" style="width:100%;height:100%;">
    <div
      style="width: 1400px;height: 380px;margin: auto;display: flex;align-items: center;justify-content: center;flex-direction: row;justify-content: space-between;">
      <div
        style="background: #FFFFFF;width: 826px;height: 100%;display: flex;align-items: center;justify-content: center;flex-direction: row;justify-content: space-between;">
        <div style="width: 273px;height: 100%;display: flex;align-items: center;flex-direction: column;">
          <div
            style="width:80px;height:80px;border:1px solid black;border-radius:40px;overflow:hidden;margin-top: 36px;margin-bottom: 20px;">
            <img width="80px" height="80px" :src="headPicUrl" />
          </div>
          <p style="font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #292929;margin: 0 0 27px 0;padding: 0;">{{ userInfo.nickname }}</p>
          <div
            style="width: 200px;height: 44px;display: flex;align-items: center;justify-content: center;border: 1px solid #ECECEC;">
            <div
              style="width: 72px;height: 44px;background: #F5F5F5;display: flex;align-items: center;justify-content: center;font-size: 14px;">
              推广码</div>
            <div style="width: 128px;height: 44px;background: #FFFFFF;display: flex;align-items: center;justify-content: center;font-size: 20px;
            font-family: Microsoft YaHei;font-weight: 400;color: #347BFF;">{{ userInfo.code }}</div>
          </div>
          <div
            style="width: 200px;height: 44px;display: flex;align-items: center;justify-content: center;border: 1px solid #ECECEC;margin-top: 20px;margin-bottom: 20px;">
            <div
              style="width: 72px;height: 44px;background: #F5F5F5;display: flex;align-items: center;justify-content: center;font-size: 14px;">
              推广系数</div>
            <div style="width: 128px;height: 44px;background: #FFFFFF;display: flex;align-items: center;justify-content: center;font-size: 20px;
            font-family: Microsoft YaHei;font-weight: 400;color: #347BFF;">{{ userInfo.invitePrice }}</div>
          </div>
          <router-link to="/spreader/personalData" style="width:148px;height:44px;line-height:44px;text-align: center;
          border-radius: 4px;border: 0px;font-size: 16px;background: #347BFF;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;text-decoration: none;" exact>编辑资料</router-link>
        </div>
        <div style="width: 1px;height: 348px;background: #949494;opacity: 0.2;"></div>
        <div style="width: 552px;height: 100%;display: flex;align-items: center;flex-direction: column;">
          <p
            style="width: 480px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;margin: 29px 0 10px 0;padding: 0;">
            账户明细</p>
          <div style="width: 480px;height: 192px;background: #F0F1F7;opacity: 0.8;border-radius: 6px;">
            <div
              style="width: 480px;height: 70px;display: flex;align-items: center;justify-content: center;flex-direction: row;padding-top: 30px;">
              <div
                style="width: 120px;height: 100%;background:;text-align:center;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <p
                  style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;padding-bottom: 10px;">
                  未结算推广人数</p>
                <div :class="spreaderHome1" @mouseover="mouseover(1)" @mouseout="mouseout(1)" :title="reminder1"
                  style="width: 120px;height:52px;line-height: 52px;background: #F3F5FE;opacity: 0.8;border-radius: 6px;">
                  {{ userInfo.noCountInviteNum }}
                </div>
              </div>
              <div
                style="width: 120px;height: 100%;margin: 0 24px;text-align:center;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <p
                  style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;padding-bottom: 10px;">
                  可提现余额</p>
                <div :class="spreaderHome2" @mouseover="mouseover(2)" @mouseout="mouseout(2)" :title="reminder2"
                  style="width: 120px;height:52px;line-height: 52px;background: #F3F5FE;opacity: 0.8;border-radius: 6px;">
                  {{ userInfo.getBalance }}</div>
              </div>
              <div
                style="width: 120px;height: 100%;text-align:center;display: flex;align-items: center;justify-content: center;flex-direction: column;">
                <p
                  style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #595959;padding-bottom: 10px;">
                  已提现金额</p>
                <div :class="spreaderHome3" @mouseover="mouseover(3)" @mouseout="mouseout(3)" :title="reminder3"
                  style="width: 120px;height:52px;line-height: 52px;background: #F3F5FE;opacity: 0.8;border-radius: 6px;">
                  {{ userInfo.gotBalance }}</div>
              </div>
            </div>
            <div
              style="width: 480px;height: 82px;display: flex;align-items: center;justify-content: center;padding-top: 10px;">
              <button style="width:88px;height:32px;background: #347BFF;border-radius: 4px;border: 0px;font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;cursor: pointer;" @click="getSpreaderInfo">提现</button>
            </div>
          </div>
          <p style="width: 480px;font-size: 12px;font-family: Microsoft YaHei;font-weight: 400;
            color: #595959;margin: 24px 0 12px 0;padding: 0;">
            白小狐推广平台用户规则
          </p>
          <div style="width: 480px;">
            <span style="width: 426px;height:54px;display: block;line-height: 18px;
              font-size: 12px;font-family: Microsoft YaHei;
              font-weight: 400;color: #999999;overflow: hidden;text-overflow: ellipsis;">
              {{ extractRuleShortStr }}
              <span style="color:#347BFF;font-size: 12px;cursor: pointer;"
                @click="withdrawRuleDialogFlag = true">点击查看</span>
            </span>
          </div>
        </div>
      </div>
      <div style="background: #FFFFFF;width: 558px;height: 100%;">
        <div style="width: 510px;height: 20px;margin: auto 0 auto 40px;display: flex;padding-top: 35px;">
          <div style="width:4px;height:20px;background: #347BFF;border-radius: 2px;"></div>
          <p style="margin:0 0 0 10px;padding:0;line-height: 20px;font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #292929;">提现详情</p>
        </div>
        <div class="spreader_home1" style="width: 510px;height: 284px;margin: 24px auto 0 auto;">
          <el-table :data="tableData" max-height="284px" :cell-style="{ background: '#F3F4F9', }"
            :header-cell-style="{ background: '#E6E8F1' }" style="width: 100%;background: #F3F4F9;">
            <el-table-column prop="id" label="序号" align="center" width="64px" :render-header="renderHeader">
            </el-table-column>
            <el-table-column prop="applayDate" align="center" width="89px" :render-header="renderHeader" label="申请日期">
              <template slot-scope="props">
                <span style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;">{{ props.row.applayDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="withdrawalDate" align="center" width="89px" :render-header="renderHeader"
              label="提现日期">
              <template slot-scope="props">
                <span style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;">{{ props.row.withdrawalDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" align="center" :render-header="renderHeader" label="提现状态">
              <template slot-scope="props">
                <span v-if="props.row.status == 0" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #347BFF;">
                  <div class="circle circle_1"></div>审核中
                </span>
                <span v-else-if="props.row.status == 1" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #05C429;">
                  <div class="circle circle_2"></div>提现成功
                </span>
                <span v-else style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #E74A4A;">
                  <div class="circle circle_3"></div>被驳回
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="cause" align="center" :render-header="renderHeader" label="原因">
              <template slot-scope="props">
                <span v-if="props.row.status == 0" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #D6D6D6;">详情</span>
                <el-popover v-else-if="props.row.status == 1" placement="top-start" title="原因" width="200"
                  trigger="hover">
                  <div>{{ props.row.cause }}</div>
                  <span slot="reference" style="font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #595959;cursor: pointer;">详情</span>
                </el-popover>
                <el-popover v-else placement="top-start" title="原因" width="200" trigger="hover">
                  <div>{{ props.row.cause }}</div>
                  <span slot="reference" style="font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #595959;cursor: pointer;">详情</span>
                </el-popover>

              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" :render-header="renderHeader" label="金额">
              <template slot-scope="props">
                <span v-if="props.row.status == 0" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #595959;">+${{ props.row.price }}</span>
                <span v-else-if="props.row.status == 1" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #EF610B;">+${{ props.row.price }}</span>
                <span v-else style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #D6D6D6;">+${{ props.row.price }}</span>
              </template>
            </el-table-column>
            <div slot="empty" style="width:100%;height:100%;background: #F3F4F9;">
              <img src="../../assets/spreader/nodata.png" style="width: 192px; height: 136px;margin-top: 40px;" />
              <span style="display:block;font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;">暂无查询数据</span>
            </div>
          </el-table>
        </div>
      </div>
    </div>
    <div style="width: 1400px;margin: 16px auto 0 auto;background: #FFFFFF;padding-bottom: 50px;">
      <div style="width:1328px;margin:auto;">
        <div style="height: 20px;display: flex;padding-top: 35px;">
          <div style="width:4px;height:20px;background: #347BFF;border-radius: 2px;"></div>
          <p style="margin:0 0 0 10px;padding:0;line-height: 20px;font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #292929;">盈利记录</p>
          <span style="margin: 0 0 0 10px;font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;">*支付信息因需要审核，消费记录仅能查询到{{ days }}个工作日前的数据，请谅解；</span>
        </div>
        <div style="padding: 22px 0 0 0;position: relative;">
          <el-form :inline="true" ref="form" :model="form" label-width="80px">
            <el-form-item label="结算状态:" class="spreader_home3">
              <el-select v-model="form.status" placeholder="请选择" style="width:130px;">
                <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推广时间:" class="spreader_home4">
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="开始时间"
                v-model="form.spreadStartDate" style="width: 150px;"></el-date-picker>
              <span>——</span>
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束时间"
                v-model="form.spreadEndDate" style="width: 150px;"></el-date-picker>
            </el-form-item>
            <el-form-item label="结算时间:" class="spreader_home4">
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="开始时间"
                v-model="form.settAccoStartDate" style="width: 150px;"></el-date-picker>
              <span>——</span>
              <el-date-picker type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="结束时间"
                v-model="form.settAccoEndDate" style="width: 150px;"></el-date-picker>
            </el-form-item>
            <el-form-item style="position: absolute;right: 0;margin-right: 0px;">
              <el-button type="primary" @click="getSpreaderGainData" style="">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="display: flex;align-content: center;position: relative;">
          <span style="font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #595959;line-height: 36px;padding: 0 0 0 12px;">当前结算金额 (点击结算到账户余额)：</span>
          <el-input v-model="gainPriceTotal" :disabled="true" class="spreader_home5" style="width: 128px;height:36px">
          </el-input>
          <el-button style="width:88px;height:36px;font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #347BFF;margin: auto 0 auto 10px;cursor: pointer;" @click="settleAccounts">结算</el-button>

          <span style="font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #595959;line-height: 36px;position: absolute;right: 0;">
            当前搜索到的有效推广用户数量：{{ userNum }}
          </span>
        </div>
        <div style="margin: 16px 0 0 0;background: #F3F4F9;">
          <el-table :data="profitTableData" :cell-style="{ background: '#F3F4F9', }"
            :header-cell-style="{ background: '#E6E8F1' }" :default-expand-all="expandDallFlag"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" row-key="id"
            style="width: 100%; background: #F3F4F9;">
            <el-table-column prop="account" label="用户账号" align="center" width="200px" show-overflow-tooltip
              :render-header="renderHeader">
            </el-table-column>
            <el-table-column prop="orderNum" align="center" width="150px" show-overflow-tooltip
              :render-header="renderHeader" label="订单号">

              <template slot-scope="props">
                <span v-if="props.row.orderNum != undefined" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #05C429;">{{ props.row.orderNum }}</span>
                <span v-else style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #05C429;">暂无交易</span>
              </template>

            </el-table-column>
            <el-table-column prop="inviterDate" align="center" :render-header="renderHeader" label="邀请时间">
            </el-table-column>
            <el-table-column prop="orderPayDate" align="center" :render-header="renderHeader" label="消费时间">
            </el-table-column>
            <el-table-column prop="productPrice" align="center" :render-header="renderHeader" label="消费金额">
            </el-table-column>
            <el-table-column prop="gainPrice" align="center" :render-header="renderHeader" label="盈利金额">
            </el-table-column>
            <el-table-column prop="status" align="center" :render-header="renderHeader" label="结算状态">
              <template slot-scope="props">
                <span v-if="props.row.status == 0" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #347BFF;">待结算</span>
                <span v-else-if="props.row.status == 1" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #E74A4A;">不可结算</span>
                <span v-else-if="props.row.status == 2" style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #05C429;">结算成功</span>
                <span v-else style="font-size: 12px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #05C429;"></span>
              </template>
            </el-table-column>
            <el-table-column prop="settleAccountsDate" align="center" :render-header="renderHeader" label="结算日期">
            </el-table-column>
            <el-table-column prop="cause" align="center" :render-header="renderHeader" label="审核原因">
              <template slot-scope="props">

                <el-popover v-if="props.row.status == 1" placement="top-start" title="原因" width="200" trigger="hover">
                  <div>{{ props.row.cause }}</div>
                  <span slot="reference" style="width: 60px;
                  height: 26px;
                  border: 1px solid #D0D2D9;
                  border-radius: 13px;font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #595959;display: inline-block;cursor: pointer;">详情</span>
                </el-popover>
              </template>
            </el-table-column>
            <div slot="empty" style="width:100%;height:100%;background: #F3F4F9;">
              <img src="../../assets/spreader/nodata.png" style="width: 192px; height: 136px;margin-top: 40px;" />
              <span style="display:block;font-size: 12px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;">暂无查询数据</span>
            </div>
          </el-table>
          <div v-if="profitTableData.length > 0"
            style="display:flex;align-items: center;justify-content: center;padding: 40px 0 40px 0;">
            <el-pagination background layout="prev, pager, next" :total="total" @current-change="currentChangeEvents">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="spreader_index3" width="560px" :visible.sync="withdrawAffirmDialogFlag" :destroy-on-close="true"
      :show-close="false" center>
      <div
        style="width:100%;height:48px;background: #347BFF; 
        display: flex;justify-content: space-between;align-items: center;border-top-left-radius:18px;border-top-right-radius:18px;">
        <span style="font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #FFFFFF;margin-left: 25px;">提现信息</span>
        <img width='24px' height='24px' src='../../assets/spreader/close.png' @click="withdrawAffirmDialogFlag = false"
          style="margin-right:25px" />
      </div>
      <div style="width:500px;padding:30px;display: flex;">
        <img width="20px" height="20px" src="../../assets/spreader/hint.png" style="display:inline-block;" />
        <p style="font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          line-height: 20px;margin: 0;padding: 0 0 0 10px;">请确认以下您的个人信息，方便您能更好的去提现。如果出现信息不一致，请您返回首页进行个人信息的编辑修改</p>
      </div>
      <div class="spreader_home7" style="width: 500px;
        background: #F3F4F9;
        opacity: 0.8;margin: auto;padding: 0 0 30px 0;">
        <div class="spreader_home6"
          style="display:flex;justify-content: space-between;align-items: center;width: 410px;margin: auto;padding-top: 30px;">
          <span style="width:16%; text-align: right;font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #292929;">真实姓名</span>
          <el-input type="text" disabled v-model="userInfo.idCardName"></el-input>
        </div>
        <div class="spreader_home6"
          style="display:flex;justify-content: space-between;align-items: center;width: 410px;margin: auto;padding-top: 30px;">
          <span style="width:16%; text-align: right;font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #292929;">手机号</span>
          <el-input type="text" disabled v-model="userInfo.tel"></el-input>
        </div>
        <div class="spreader_home6"
          style="display:flex;justify-content: space-between;align-items: center;width: 410px;margin: auto;padding-top: 30px;">
          <span style="width:16%; text-align: right;font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #292929;">身份证号</span>
          <el-input type="text" disabled v-model="userInfo.idCardNum"></el-input>
        </div>
        <div class="spreader_home6"
          style="display:flex;justify-content: space-between;align-items: center;width: 410px;margin: auto;padding-top: 30px;">
          <span style="width:16%; text-align: right;font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #292929;">银行开户行</span>
          <el-input type="text" disabled v-model="userInfo.bankCardName"></el-input>
        </div>
        <div class="spreader_home6"
          style="display:flex;justify-content: space-between;align-items: center;width: 410px;margin: auto;padding-top: 30px;">
          <span style="width:16%; text-align: right;font-size: 12px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #292929;">银行卡号</span>
          <el-input type="text" disabled v-model="userInfo.bankCardNum"></el-input>
        </div>
      </div>
      <div style="padding: 40px 0 40px 0;">
        <el-button type="primary" style="width:320px;height:52px;margin:auto;display: block;"
          @click="clickExtractButton">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="withdrawRuleDialogFlag" width="51%">
      <h1 style="text-align: center;margin: 0;padding: 0 0 20px 0;">白小狐推广平台用户规则</h1>
      <div style="font-size: 16px;line-height: 28px;width: 92%;margin: auto;">
        <span v-html="welcomeStr"></span>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="withdrawRuleDialogFlag = false">我知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false"
      :visible.sync="welcomeDialogFlag" width="45%">
      <h1 style="text-align: center;margin: 0;padding: 0 0 20px 0;">白小狐推广平台用户规则</h1>
      <div style="font-size: 16px;line-height: 28px;">
        <span v-html="welcomeStr"></span>
      </div>
      <div style="padding-top:30px;display: flex;justify-content: center;">
        <el-checkbox v-model="iKnowFlag" @change="change1">我已全面读懂并了解同意本文件内容!</el-checkbox>
      </div>

      <span slot="footer" class="dialog-footer" style="display:flex;justify-content: space-around;">
        <el-button type="primary" @click="disagree">不同意</el-button>
        <el-button type="primary" @click="onclickWelComeStrKnow" :disabled="iKnowButtonFlag">我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getId } from '@/utils/auth'
import { getProtocolStatus, setProtocolStatus } from '@/api/spreader/user';
import { settleAccounts, gainlist,getdays } from '@/api/spreader/gain';
import { extractlist } from '@/api/spreader/extract';
import { getConfigs, getConfig } from '@/api/spreader/config';


export default {
  name: "spreader_home",
  props: {
    userInfo: {
      nickname: '',
      headPic: '',
      code: '',
      getBalance: '',
      gotBalance: '',
      inviterNum: '',
      idCardName: '',
      tel: '',
      idCardNum: '',
      bankCardName: '',
      bankCardNum: '',
      invitePrice: '',
      noCountInviteNum: '',
    },
    headPicUrl: '',
  },
  components: {
  },
  created() {
    new Promise((resolve, reject) => {
      getProtocolStatus().then(res => {
        if (res.status == 200) {
          if (res.data == 1) {
            this.welcomeDialogFlag = false
          } else {
            this.welcomeDialogFlag = true
          }
        } else {
          this.$message(res.message);
        }
      })
    })

    this.getDays()
  },
  destroyed: function () {
  },
  mounted: function () {
    this.getSpreaderGainData();
    this.getExtractData();
    this.getExtractRuleStr();
    this.getWelcomeStr();
    this.spreaderHome1 = 'spreader_home_0';
    this.spreaderHome2 = 'spreader_home_0';
    this.spreaderHome3 = 'spreader_home_0';

  },
  methods: {
    change1(value) {
      if (value == true) {
        this.iKnowButtonFlag = false;
      } else {
        this.iKnowButtonFlag = true;
      }
    },
    //点击确定提现
    clickExtractButton() {
      this.$router.push('/spreader/withdraw');
    },
    //点击结算
    settleAccounts() {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let data = {
        spreaderId: userInfo.id,
        gainIds: this.gainIds,
        gainPriceTotal: this.gainPriceTotal,
        appUserIds: this.appUserIds
      }
      return new Promise((resolve, reject) => {
        settleAccounts(data).then(res => {
          if (res.status == 200) {
            this.$emit('getInfo')
            this.getSpreaderGainData();
            this.$message('结算成功，请查看余额');
          } else {
            this.$message(res.message);
          }
          this.withdrawAffirmDialogFlag = false;
        });
      })
    },
    renderHeader(h, { column }) {
      // h即为cerateElement的简写，具体可看vue官方文档
      return h("div", [
        h("span", column.label),
        h(),
      ]);
    },
    //获取盈利数据
    getSpreaderGainData() {
      this.form.spreaderId = getId();
      return new Promise((resolve, reject) => {
        gainlist(this.form).then(res => {
          if (res.status == 200) {
            this.gainIds = res.data.gainIds;
            this.appUserIds = res.data.appUserIds;
            this.gainPriceTotal = res.data.gainPriceTotal;
            this.profitTableData = res.data.records;
            this.total = parseInt(res.data.total);
            this.userNum = res.data.userNum;
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    //获取提现数据
    getExtractData() {
      return new Promise((resolve, reject) => {
        extractlist().then(res => {
          if (res.status == 200) {
            this.tableData = res.data;
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    //改变页码
    currentChangeEvents(currentPage) {
      this.form.pageNo = currentPage;
      this.getSpreaderGainData();
    },
    //获取推广者信息
    getSpreaderInfo() {
      this.withdrawAffirmDialogFlag = true;
      this.$emit('getInfo')
    },
    //获取提现规则字符串
    getExtractRuleStr() {
      let data = {
        ids: [12, 18, 19, 20]
      }
      return new Promise((resolve, reject) => {
        getConfigs(data).then(res => {
          if (res.status == 200) {
            res.data.forEach(element => {
              if (element.id == 18) {
                this.reminder1 = element.zh;
              }
              if (element.id == 19) {
                this.reminder2 = element.zh;
              }
              if (element.id == 20) {
                this.reminder3 = element.zh;
              }
            });
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    getWelcomeStr() {
      let data = {
        cid: 32
      }
      return new Promise((resolve, reject) => {
        getConfig(data).then(res => {
          if (res.status == 200) {
            this.extractRuleShortStr = res.data.zh.replace(/<.*?>/g, '').substring(0, 100) + '...';
            this.welcomeStr = res.data.zh
          } else {
            this.$message(res.message);
          }
        });
      })
    },
    //不同意
    disagree() {
      sessionStorage.removeItem("userInfo");
      this.$router.push('/spreader/login');
    },
    onclickWelComeStrKnow() {
      return new Promise((resolve, reject) => {
        setProtocolStatus().then(res => {
          if (res.status == 200) {
            this.welcomeDialogFlag = false;
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    //鼠标移入
    mouseover(flag) {
      if (flag == 1) {
        this.spreaderHome1 = 'spreader_home_1'
      }
      if (flag == 2) {
        this.spreaderHome2 = 'spreader_home_1'
      }
      if (flag == 3) {
        this.spreaderHome3 = 'spreader_home_1'
      }

    },
    //鼠标移出
    mouseout(flag) {
      if (flag == 1) {
        this.spreaderHome1 = 'spreader_home_0'
      }
      if (flag == 2) {
        this.spreaderHome2 = 'spreader_home_0'
      }
      if (flag == 3) {
        this.spreaderHome3 = 'spreader_home_0'
      }
    },
    getDays() {
      return new Promise((resolve, reject) => {
        getdays().then(res => {
          if (res.status == 200) {
            this.days = res.data
          } else {
            this.$message(res.message);
          }
        })
      })
    }
  },
  data() {
    return {
      days: 3,

      reminder1: '',
      reminder2: '',
      reminder3: '',

      withdrawAffirmDialogFlag: false,
      expandDallFlag: false,
      gainIds: [],
      userNum: 0,
      gainPriceTotal: 0,
      total: 0,
      form: {
        spreaderId: '',
        status: '',
        spreadStartDate: '',
        spreadEndDate: '',
        settAccoStartDate: '',
        settAccoEndDate: '',
        pageNo: 1,
        pageSize: 10,
      },
      statusOptions: [
        {
          value: '',
          label: '全部'
        },
        {
          value: '0',
          label: '待结算'
        },
        {
          value: '1',
          label: '不可结算'
        },
        {
          value: '2',
          label: '结算成功'
        }],
      profitTableData: [],
      tableData: [],
      extractRuleShortStr: '',
      extractRuleStr: '',
      withdrawRuleDialogFlag: false,
      spreaderHome1: '',
      spreaderHome2: '',
      spreaderHome3: '',

      welcomeDialogFlag: false,
      welcomeStr: '',

      iKnowFlag: false,
      iKnowButtonFlag: true,
    };
  },
};
</script>

<style>
.spreader_home1 th {
  margin: 0;
  padding: 0;
}

.spreader_home4 {
  margin: 0 0 0 45px;
}

.spreader_home5 input {
  height: 36px;
  line-height: 36px;
}

.el-table .el-table__row .el-table__cell {
  border-bottom: 1px solid #ffffff;
}

.spreader_home6 .el-input {
  width: 80%;
}

.spreader_home7 .el-table__empty-text {
  width: 100%;
}

.circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  display: inline-block;
  margin-bottom: 2px;
  margin-right: 5px;
}

.circle_1 {
  background-color: #347BFF;
}

.circle_2 {
  background-color: #05C429;
}

.circle_3 {
  background-color: #E74A4A;
}

.overflowEllipsisStyle {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.spreader_home_0 {
  border: 1px solid #D0D2D9;
}

.spreader_home_1 {
  border: 1px solid #2a2aec;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/home.vue